import Header from "../Component/UserEnd/Header";
import Faq from "../Component/UserEnd/Faq";
import Footer from "../Component/UserEnd/Footer";

function FaqPage() {
    return (
        <>
            <Header />
            <Faq/>
            <Footer />
        </>
    );
}

export default FaqPage;
